import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState, forwardRef } from "react";
import getReadingsTableData from "./data/readingTableData";
import { getAccountCall } from "api/api";
import history from "../../helpers/history";
import formatCurrency from "helpers/formatCurrency";
import getPaymentsTableData from "./data/paymentTableData";
import Loader from "components/loader/loader";
import { CheckPermissionRender, checkPermission } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import TabView from "../../components/TabView/tab_view";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";
import { useStoreActions, useStoreState } from "easy-peasy";
import { Dialog, Slide } from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Account() {
  const readingImage = useStoreState((state) => state.readingImage);
  const setReadingImage = useStoreActions((actions) => actions.setReadingImage);
  const [state, setState] = useState({
    holderName: "",
    holderMobile: "",
    holderAddress: "",
    accountNo: "",
    currentBalance: "",
    readings: {
      columns: [],
      rows: [],
    },
    payments: {
      columns: [],
      rows: [],
    },
    createModalOpen: false,
    loading: true,
  });

  const isMobile = useIsMobile();

  const getAccount = async (id) => {
    const account = await getAccountCall(id);
    if (account) {
      const { columns: readingColumns, rows: readingRows } = getReadingsTableData(
        account.readings,
        setReadingImage
      );
      const { columns: paymentColumns, rows: paymentRows } = getPaymentsTableData(account.payments);
      setState({
        ...state,
        holderName: account.holder_name,
        holderMobile: account.phone_number,
        holderAddress: account.address,
        accountNo: account.account_number,
        currentBalance: account.current_balance,
        readings: {
          columns: readingColumns,
          rows: readingRows,
        },
        payments: {
          columns: paymentColumns,
          rows: paymentRows,
        },
        createModalOpen: false,
        loading: false,
      });
    } else {
      setState({ ...state, loading: false });
    }
  };

  useEffect(() => {
    const id = history?.location?.pathname?.split("/")[2];
    if (id) {
      getAccount(id);
    }
  }, []);

  const Author = ({ name, accNo, address }) => {
    return (
      <MDBox
        display="flex"
        alignItems="center"
        lineHeight={1}
        style={{
          cursor: "pointer",
        }}
      >
        <MDBox lineHeight={1}>
          <MDTypography
            display="block"
            variant="button"
            fontWeight="medium"
            color="white"
            fontSize="medium"
          >
            {`${name} | Acc: ${accNo}`}
          </MDTypography>
          <MDTypography variant="caption" color="white">
            {address}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const Balance = ({ balance }) => {
    return (
      <MDBox
        width="fit-content"
        display="flex"
        alignItems="center"
        lineHeight={1}
        style={{
          cursor: "pointer",
          backgroundColor: "#000000c2",
          padding: "2px 10px",
          borderRadius: "10px",
        }}
      >
        <MDTypography fontSize={15} color="white" mr={2}>
          Balance:{" "}
        </MDTypography>
        <MDTypography fontSize={15} fontWeight={"bold"} color={balance >= 0 ? "success" : "error"}>
          {formatCurrency(balance)}
        </MDTypography>
      </MDBox>
    );
  };

  const getTabs = () => {
    const tabs = [];
    if (checkPermission(permissions().consumption().read().list())) {
      tabs.push({
        title: "Consumption",
        component: (
          <MDBox pt={3}>
            <DataTable
              table={{ columns: state.readings.columns, rows: state.readings.rows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
              showPagination={true}
            />
          </MDBox>
        ),
      });
    }
    if (checkPermission(permissions().payment().read().list())) {
      tabs.push({
        title: "Payments",
        component: (
          <MDBox pt={3}>
            <DataTable
              table={{ columns: state.payments.columns, rows: state.payments.rows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
              showPagination={true}
            />
          </MDBox>
        ),
      });
    }
    return tabs;
  };

  const ReadingImageView = () => {
    return (
      <Dialog
        open={!!readingImage}
        TransitionComponent={Transition}
        onClose={() => setReadingImage(null)}
      >
        <img src={readingImage} style={{ maxWidth: "400px", width: "100%", minWidth: "300px" }} />
      </Dialog>
    );
  };

  return state.loading ? (
    <Loader />
  ) : (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={2}
              >
                <Author
                  name={state.holderName}
                  accNo={state.accountNo}
                  address={state.holderAddress}
                />
                <CheckPermissionRender permissions={permissions().payment().read().create().list()}>
                  <Balance balance={state.currentBalance} />
                </CheckPermissionRender>
              </MDBox>

              <MDBox mt={3}>
                <TabView tabs={getTabs()} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ReadingImageView />
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Account;
